<template>
  <div>
    <van-tabs type="card" v-model="activeName" swipeable sticky :offset-top="scrollTop" ref="tabsDom">
      <van-tab :title="itemTab.title" :name="itemTab.name" v-for="(itemTab,index) in tabs" :key="index">
        <template #title v-if="itemTab.name==0">
          <i class="dot" v-show="num">{{num}}</i>未对接
        </template>
        <van-sticky :offset-top="scrollTop+tabsDomHeight">
          <van-row class="head">
            <van-col span="6">手机号</van-col>
            <van-col span="6">姓名</van-col>
            <van-col span="6">申请额度(万)</van-col>
            <van-col span="6">提交时间</van-col>
          </van-row>
        </van-sticky>

        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" offset="50">
          <van-cell v-for="item in financingList" :key="item.id" @click="getId(item.id)">
            <van-row class="list">
              <div v-show="!activeName" class="no-docking">
                <span>新</span>
              </div>
              <van-col span="6">{{item.phone}}</van-col>
              <van-col span="6" class="van-multi-ellipsis--l2">{{item.username}}</van-col>
              <van-col span="6">{{item.apply_credit}}</van-col>
              <van-col span="6" class="van-multi-ellipsis--l2">{{item.created_at}}</van-col>
            </van-row>
            <transition name="van-fade">
              <van-row class="operation" v-show="item.id === id">
                <van-col :span="!activeName?8:24" @click.stop="CheckTheFinancing">查看</van-col>
                <van-col span="8" @click.stop="docking" v-show="!activeName">对接</van-col>
                <van-col span="8" @click.stop="delese" v-show="!activeName">删除</van-col>
              </van-row>
            </transition>
          </van-cell>
        </van-list>
      </van-tab>
    </van-tabs>

    <!-- 详情展示框 -->
    <van-popup v-model="show" round close-icon="close" closeable position="bottom" :style="{ height: '90%' }">
      <h5 class="popup-title">详细信息</h5>
      <div class="information">
        <div class="popup-header">企业基本信息</div>
        <p>姓名：{{financingDetails.username}}</p>
        <p>手机号：{{financingDetails.phone}}</p>
        <p>企业名称：{{financingDetails.company_name}}</p>
        <p>
          企业地址：{{financingDetails.company_province}}-{{financingDetails.company_city}}-{{financingDetails.company_county}}
        </p>
        <p>申请额度：{{financingDetails.apply_credit}}(万元)</p>
        <p>知产信息：{{financingDetails.property_info}}</p>
        <p v-show="activeName">对接人：{{financingDetails.dock_admin}}</p>
        <p v-show="activeName">对接时间：{{financingDetails.dock_at}}</p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { financingNeedList, financingNeedUpdate } from '@/api/financing.js'
import delItem from '@/utils/delitem.js'
export default {
  name: 'needs',
  props: {
    inpshow: {
      type: Boolean,
      default: false
    },
    searchVal: {
      type: String,
      default: ''
    },
    scrollTop: {
      type: Number,
      default: 44
    }
  },
  data () {
    return {
      tabs: [
        { title: '未对接', name: 0 },
        { title: '已对接', name: 1 }
      ],
      activeName: 0,
      id: null,
      show: false, // 详情展示框
      isSearch: false, // 判断要获取搜索数据还是所有数据
      financingList: [], // 数据列表
      financingDetails: {}, // 数据详情
      num: '', // 未对接数量
      page: 0,
      loading: false,
      finished: false,
      isData: false, // 是否停止加载 true：停止加载，false：继续加载
      tabsDomHeight: 0, // 头部高度
      source: null
    }
  },
  watch: {
    inpshow (newVal, oldVal) {
      if (this.searchVal) {
        this.id = -1
        this.isSearch = false
        this.onLoad(true)
      }
    },
    searchVal (newVal, oldVal) {
      this.id = -1
      this.isSearch = true
      this.onLoad(true)
    },
    activeName (newVal, oldVal) {
      if (this.source) {
        this.source.cancel({ type: 409, msg: '操作频繁' })
      }
      this.onLoad(true)
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.tabsDomHeight = this.$refs.tabsDom.$children[0].$el.offsetHeight
    })
  },
  methods: {
    getId (id) {
      if (this.id === id) {
        this.id = -1
      } else {
        this.id = id
      }
    },

    // 分页加载
    async onLoad (type) {
      if (type) {
        this.financingList = []
        this.page = 0
        this.loading = true
        this.finished = false
        this.isData = false
      }
      this.page += 1
      if (this.isSearch) {
        await this.getfinancingList(this.activeName, this.page, this.searchVal)
      } else {
        await this.getfinancingList(this.activeName, this.page)
      }
      await this.$delay(800)
      this.loading = false
      if (this.isData) {
        this.loading = false
        this.finished = true
      } else {
        this.finished = false
      }
    },
    // 项目列表数据
    async getfinancingList (type, page, searchVal) {
      this.source = this.$Axios.CancelToken.source()
      try {
        const data = await financingNeedList(type, page, searchVal, this.source.token)
        if (data.error_code === 1) {
          if (this.activeName === type) {
            if (type === 0) {
              this.num = data.data.count
            }
            this.financingList = [...this.financingList, ...data.data.data]
          }
          if (data.data.data.length < 10) {
            this.isData = true
          } else {
            this.isData = false
          }
        } else {
          this.$toast('搜索失败')
        }
      } catch (error) {
        this.isData = true
        if (error.message.type === 409) {
          this.$toast(error.message.msg)
        }
      }
    },

    // 查看详情
    async CheckTheFinancing () {
      this.show = true
      this.financingDetails = this.financingList.find(item => item.id === this.id) || {}
    },

    // 对接
    docking () {
      this.$dialog
        .confirm({
          title: '是否确认对接该条信息?',
          confirmButtonColor: '#2DADB1'
        })
        .then(() => {
          this.UpdateData(1)
        })
        .catch(() => {
          this.$dialog.close()
        })
    },

    // 删除
    delese () {
      this.$dialog
        .confirm({
          title: '是否确认删除该条信息?',
          confirmButtonColor: '#2DADB1'
        })
        .then(() => {
          this.UpdateData(2)
        })
        .catch(() => {
          this.$dialog.close()
        })
    },

    async UpdateData (type) {
      try {
        const data = await financingNeedUpdate(type, this.id)
        if (data.error_code === 1) {
          this.financingList = delItem(this.financingList, this.id)
          this.$toast('操作成功')
          this.id = -1
          this.onLoad()
        } else {
          this.$toast('操作失败')
        }
      } catch (error) {
        return error.message
      }
    }
  }
}
</script>
<style scoped lang="less">
/deep/ .van-tabs__nav--card {
  margin: 0;
  border: none;
}
/deep/ [class*="van-hairline"]::after {
  border: none;
}
/deep/ .van-tabs__nav--card .van-tab {
  border: none;
  color: #6c6c6c;
  font-size: 24px;
  background-color: #f3f1f1;
}
/deep/ .van-tabs--card .van-tabs__wrap,
/deep/ .van-tabs--card .van-tabs__wrap .van-tabs__nav {
  background-color: #fbfbfb;
}
/deep/ .van-tabs__nav--card {
  height: 90px !important;
  line-height: 90px;
  padding-bottom: 10px;
}
/deep/ .van-tabs__nav--card .van-tab.van-tab--active {
  background: rgba(45, 173, 177, 1) !important;
  color: #fff;
}
.dot {
  min-width: 36px;
  height: 36px;
  width: auto;
  line-height: initial;
  background: rgba(232, 60, 52, 1);
  border-radius: 50%;
  text-align: center;
  color: #fff;
  font-size: 24px;
  font-weight: 400;
  display: inline-block;
  background-color: #e83c34;
  position: absolute;
  right: 90px;
  top: 8px;
}
</style>
